import React from "react";
import "./CompletedButton.css";
import Swal from "sweetalert2";

const CompletedButton = () => {
  const handleCongratulation = () => {
    Swal.fire("Congratulation! Good job..");
  };

  return (
    <div className="mt-5">
      <button onClick={handleCongratulation} className="btns btn-primary">
        Actively Completed
      </button>
    </div>
  );
};

export default CompletedButton;
